import {CoreDI} from '@gongxigames/framework/core';

export const DI = {
    LoadingScreen: Symbol('LoadingScreen'),
    SpinButtonView: Symbol('SpinButtonView'),
    ResourceManager: Symbol('ResourceManager'),
    SoundManager: CoreDI.SoundManager,
    SoundPlayer: CoreDI.SoundPlayer,
    Logic: Symbol('Logic'),
    ErrorPopup: Symbol('ErrorPopup'),
    WinPresentationUtils: Symbol('WinPresentationUtils'),
    PrizeSymbolsUtils: Symbol('PrizeSymbolsUtils'),
    TemplateUtils: Symbol('TemplateUtils'),
    ScaleService: Symbol('ScaleService'),
    ReelsScaleService: Symbol('ReelsScaleService')
};
